import { HEADER } from '_constants';
import { getFirstNotNull } from 'helpers';
import { LOGIN } from '../constants/login.constants';
import { INITIAL_APP_STATE } from '../constants/common.constants';

export const header = (state = {}, action) => {
  let newState = { ...state };
  switch (action.type) {
    case HEADER.UPDATE_HEADER:
      newState.showHeader = getFirstNotNull(action.payload && action.payload.showHeader, newState.showHeader, true);
      newState.headerTitle = getFirstNotNull(action.payload && action.payload.headerTitle, newState.headerTitle, 'Xome Pro');
      newState.hasBackButton = getFirstNotNull(action.payload && action.payload.hasBackButton, newState.hasBackButton, false);
      newState.backButtonIcon = getFirstNotNull(action.payload && action.payload.backButtonIcon, newState.backButtonIcon, 'back');
      newState.hasNotificationIcon = getFirstNotNull(action.payload && action.payload.hasNotificationIcon, newState.hasNotificationIcon, true);
      newState.noIcons = getFirstNotNull(action.payload && action.payload.noIcons, action.noIcons, false);
      newState.showFooterWithBackButton = getFirstNotNull(action.payload && action.payload.showFooterWithBackButton, false);
      newState.headerClassName = getFirstNotNull(action.payload && action.payload.headerClassName, '');
      newState.prevState = state;
      break;
    case HEADER.TOGGLE_READ_LOADER:
      newState.isLoadingRead = action.isLoadingRead;
      break;
    case HEADER.TOGGLE_WRITE_LOADER:
      newState.isLoadingWrite = action.isLoadingWrite;
      break;
    case LOGIN.LOGOUT:
      newState = INITIAL_APP_STATE.header;
      break;
    default:
      break;
  }
  return newState;
};
